import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CardModule } from 'primeng/card';

import { UrlTarget } from '@ppg/core/enums';
import { CardAssetDocument } from '@ppg/core/models';

import { CardArrowUpRightComponent } from '../../../../shared/card-arrow-up-right/card-arrow-up-right.component';
import { CardDescriptionComponent } from '../../../../shared/card-description/card-description.component';
import { CardTitleComponent } from '../../../../shared/card-title/card-title.component';
import { CtaCardTemplateComponent } from '../../../../shared/cta-card-template/cta-card-template.component';

@Component({
  selector: 'ppg-list-presentation-asset-document-card',
  standalone: true,
  imports: [
    CardModule,
    CtaCardTemplateComponent,
    CardTitleComponent,
    CardDescriptionComponent,
    CardArrowUpRightComponent,
  ],
  templateUrl: './asset-document-card.component.html',
  styleUrl: '../../../../container-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListPresentationAssetDocumentCardComponent {
  readonly listAssetDocumentCard = input.required<CardAssetDocument>();

  readonly urlTarget = UrlTarget;
}
